import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { UnarchiveBidderContainer } from "../components/unarchive-bidder/UnarchiveBidderContainer";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";
import InfoIcon from '@material-ui/icons/InfoRounded';
import { FullWidthFeedback } from "../models/full-width-feedback.model";

function UnarchiveBidder() {
  const [feedback, setFeedback] = React.useState<null | FullWidthFeedback>(null);

  const queueFeedback = (next: FullWidthFeedback) => {
    setFeedback(next);

    setTimeout(() => {
      setFeedback(null);
    }, 3000);
  }

  return (
    <>
      {
        feedback != null ? 
        <Container style={{ background: feedback.type === 'error' ? '#F32121' : '#2BC55E', color: 'white', position: 'absolute', top: '157px', left: 0, right: 0, width: '100%', maxWidth: '100%', textAlign: 'center' }}>
          <h1><InfoIcon /> {feedback.feedback}</h1>
        </Container>
        : <></>
      }

      <Container maxWidth={"lg"} style={{ paddingTop: '60px' }} fixed>
        <SecureArea memberPermission={MemberPermission.SuperAdmin}>
          <Typography variant="h4" color="primary" gutterBottom>
            Unarchive Bidder
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Type the bidder email address below to unarchive them.
          </Typography>
          <Box mt={4}>
            <UnarchiveBidderContainer queueFeedback={queueFeedback}></UnarchiveBidderContainer>
          </Box>
        </SecureArea>
      </Container>
    </>
  );
}

export default withAITracking(reactPlugin, UnarchiveBidder, "UnarchiveBidder");
